'use strict';
var tooltip = require('../tooltip'),
	util = require('../util'),
	dialog = require('../dialog'),
	validator = require('../validator'),
	imagesLoaded = require('imagesloaded'),
	ajax = require('../ajax'),
	tealium = require('../../../../int_tealium/cartridge/js/tealium/tealium'),
    progress = require('../progress');
function madeOfferAjax(rebuttal,presentation) {
	var url = util.appendParamsToUrl(Urls.madeOffer, {'rebuttal': rebuttal, 'presentation':presentation});
	ajax.load({
        url: url,
        callback: function (data) {
           //var fail = false;
           if ($('.pt_checkout .spc-summary').length > 0) {
                 require('../spc').initPreScreen();
           } else {
                 if($('.express-billing-refresh').length > 0) {
                	 $(".express-billing-refresh[data-refreshurl]").trigger('click'); 
                 } else {
                	 $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                 }
           }
	    }
	 });
}

function scrollToActiveTab(billType) {  
	var scrDiff = billType === 'expBill' ? 100 : 15;
	if(!$(".ui-dialog").is(":visible")) {
		if($('.checkout-tab-head.open').length) {
	    	$('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $('.pt_checkout #header').outerHeight() - scrDiff }, 700);
	    }
	}
}
/* PXSFCC-4238 */
function addBottomPaddingDuringStickyButtons () {
	if( $(".plcc-web-and-preapproved-form").length > 0 && $(window).width() < 1025 ) {
		var stickyButtonHeight = $(".plcc-web-and-preapproved-form").find(".bottom-buttons").outerHeight();
		$(".footer-container.footer-down").css("padding-bottom",stickyButtonHeight +"px");
	} else {
		$(".footer-container.footer-down").css("padding-bottom", 0 +"px");
	}
}
function initializeEvents() {
	// To fix SM-2414 below line has been commented
	//util.updateInputFields();
	$('input.ssn').unmask().maskSSN('999-99-9999', {maskedChar:'X', maskedCharsLength:5, numericMaskedCharEquivalent:'9'});
	if($(".billing-cards-section,.spc-summary").find("acquisition-rebuttal1")) {
        var name = $(".acquisition-rebuttal1").data("name");
        var creditLimit = $(".acquisition-rebuttal1").data("creditlimit");
        $(".plcc-pre-approved-name").text(name);
        $(".plcc-pre-approved-creditlimit").text(creditLimit);
	}
	/* PXSFCC-4238 */
	if( $(".plcc-web-and-preapproved-form").length > 0 ) {
		addBottomPaddingDuringStickyButtons();
		
		$(window).resize(function(){
			addBottomPaddingDuringStickyButtons();
		});
	}
	$("body").off("click",".heading-click").on("click",".heading-click",function(){
    	var $parent = $(this).closest(".plcc-form-section");
    	if(!$parent.hasClass("active")) {
    		$parent.addClass("active");
    		var $authorizeInfo = $('.plcc-authorized-buyer-block input,.plcc-authorized-buyer-block select');
    		$authorizeInfo.removeClass("error").closest(".form-row").removeClass("error-handle");
    		$parent.find(".plcc-authorized-buyer-section").slideDown();
    	} else {
    		$parent.removeClass("active");
    		$parent.find(".plcc-authorized-buyer-section").slideUp();
    	}
    });
	
	$("body").on('click',".plcc-edit-profile", function(e) {
        e.preventDefault();
        $(this).closest('.plcc-profile-summary').hide();
        $('.show-profile').show();
        util.updateInputFields();
    });
	
	$("body").off("keypress",".ui-dialog-titlebar-close").on("keypress",".ui-dialog-titlebar-close",function(e){
		if($(this).closest('.ui-dialog').hasClass('plcc-ssn-info-dialog')){
			if(e.type === "keypress"){
	            if (e.which !== 13) return;
	            setTimeout(function() { 
					$(".plcc-primary").find(".question-mark-icon.plcc-ssn-info").addClass("focus-outline").focus();
				 }, 10);
	        }
		}	
    });
	$("body").off("click keypress",".dialog-tooltip").on("click keypress",".dialog-tooltip",function(e){
		if(e.type === "keypress"){
            if (e.which !== 13) return;
        }
    	var content = $(this).find(".tool-tip-content,.dialog-tool-tip-content").clone();
		var tootltipDlg =  dialog.create({
			target : "#tool-dialog-container",
	        options:{ 
	            width: "360px", 
	            height: "auto",
	            dialogClass : 'tool-dialog tooltip-dialog plcc-ssn-info-dialog',
	         } 
	     });
		 $('.ui-dialog.plcc-ssn-info-dialog .ui-dialog-titlebar-close')
			.addClass('btn-ds');
		$(tootltipDlg).children().remove();
		$(tootltipDlg).append(content);
		tootltipDlg.dialog("open");
    });
	
	
	$('.submit-terms input').on('click',function(){
	    if ($(this).is(':checked')) {
			$('.submit-terms label .label-text').removeClass('error-terms');
		}
	});
	
	$("body").off('blur','input.alternativePhone').on('blur','input.alternativePhone', function(){
	    if($(this).val().length == 0) {
	    	var $formRow = $(this).closest('.form-row.alternativePhone');
	    	$formRow.removeClass('error-handle');
			$formRow.find('label span.error').hide();
	    }
	});
	$(".plcc_web_application_form, .plcc_preapproved_application_form").off("submit").on("submit",function(e){
		e.preventDefault();
		var $form = $(this).closest('form'),
			action = $form.attr("action");
		var phone =  $form.find('input.phone').val();
		var altPhone =  $form.find('input.alternativePhone').val();
	
		if($('input.alternativePhone').hasClass('phone')){
			$('.alternativePhone').removeClass('phone');
		}
		
		if ((phone == undefined || phone == '' || phone == null) && (altPhone == undefined || altPhone == '' || altPhone == null)) {
			$form.find('.phone').addClass('required');
			$form.find('input.phone').attr('data-required-text',Resources.PHONE_REQ_MESSAGE);
		} else {
			$form.find('.phone').removeClass('required');
			$form.find('input.phone').removeAttr('data-required-text');
		}
		
		var authorizeInfo = $('.plcc-authorized-buyer-block input:visible,.plcc-authorized-buyer-block select:visible');
		var isAuthorizeBuyer = false;
    	if (authorizeInfo.length > 0) {
	  		isAuthorizeBuyer = true; 
        }

		if (isAuthorizeBuyer) {
			authorizeInfo.each(function () {
				var $curObj = $(this);
				var errorText = $curObj.closest(".form-row").find(".label-text").text();
				$curObj.addClass('required');
				$curObj.attr('data-required-text',errorText);
			});
		} else {
			authorizeInfo.each(function () {
				var $curObj = $(this);
				$curObj.removeClass('required');
				$curObj.removeAttr('data-required-text');
		    	$curObj.closest(".form-row").removeClass("error-handle").addClass("show-text");
			});
		}
		if (!$form.valid()) {
			if(!($('.submit-terms input').is(':checked'))) {
				$('.submit-terms label .label-text').addClass('error-terms'); 
			}
			$('.invalid-form').removeClass('hide');
            return false;
        } else {
        	$('.submit-terms label .label-text').removeClass('error-terms');
        	$('.invalid-form').addClass('hide');
        	$(".pre-approved-submit,.web-instant-submit").attr('disabled', 'disabled');
        }
		var buttonName = $form.find("button[type='submit']").attr("name");
		$('<input type="hidden" name="' + buttonName + '" value="true" />').appendTo($form);
		$.ajax({ 
			url: action,
			data: $form.serialize(),
			method: 'POST', 
			success: function(data) {
				if(data != '') {
					$('.invalid-ssn-error').addClass('hide');
					var dialogContent = $(data);
					dialog.open({
			            html: dialogContent,
			            options: {
			                width: 700,
			                closeOnEscape  : false,
				            closeOnOverlayClick: false,
			                dialogClass: "plcc-apply-error-model",
			            },
			            callback: function () {
			            	if($('.approved-model').length > 0 ){
			            		var obj = {
			            			event_name : "plc_registration"
			                	}
			        			tealium.triggerEvent(obj);
			            	}
			            	
			            	$('.continue-shopping').on('click',function(e){
			            		e.preventDefault();
			            		window.location.assign(Urls.home);
			            	});
			            	$('.continue-checkout').on('click',function(){
			            		e.preventDefault();
			            		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");;
			            	});
			            	$('.guest-sign-in').on('click',function(e){
			            		e.preventDefault();
			            		window.location.assign(Urls.logIn);
			            	});
			            	$('.try-again').on('click',function(e){
			            		e.preventDefault();
			            		window.location.reload();
			            	});
			            }
			        });
				} else {
					if( $(".form-row.ssn").find(".server-error").length <= 0 ) {
                        var serverError = '<span class="server-error">' + $(".invalid-ssn-error").text() + '</span>';
                        $(".form-row.ssn").removeClass("show-text").addClass("error-handle").find("label").prepend(serverError);
                        $(".pre-approved-submit,.web-instant-submit").removeAttr('disabled');
					}
					//$(window).scrollTop($(".server-error").first().closest(".form-row ").offset().top);
					//$('.invalid-ssn-error').removeClass('hide');
				}
			}
			
		});
	});
	
		
}

var madeOfferCall = true;
var rebuttal = false;
var presentation = 'PREAPPROVED_NO';

var preApprovedInit = {
	rebuttal: true,
	events: function() {
		$("body").off("click",".acquisition-rebuttal").on("click",".acquisition-rebuttal",function(e) {
			e.preventDefault();
			var $modalContent = $(".acquisition-rebuttal-modal");
			var acquisitionRebuttalDlg =  dialog.create({
		        options:{ 
		            width: "700px", 
		            height: "auto",
		            closeOnEscape  : false,
		            closeOnOverlayClick: false,
		            dialogClass : 'plcc-acquisition-rebuttal-model',
		            open: function() {
						$('html').addClass('no-scroll')
						$('.checkout-body').addClass('no-scroll-checkout');
					},
		            close: function () {
		        		$('html').removeClass('no-scroll')
						$('.checkout-body').removeClass('no-scroll-checkout');
		            	madeOfferAjax(preApprovedInit.rebuttal, presentation);
		            	var obj = {
	            			event_name : "plc_offer_refused"
	                	}
	        			tealium.triggerEvent(obj);
			        }
		         } 
		     });
			validator.init();
			util.updateselect();
			util.updateInputFields();
			$(acquisitionRebuttalDlg).children().remove();
			$(acquisitionRebuttalDlg).append($modalContent.html());
			acquisitionRebuttalDlg.dialog("open");
			imagesLoaded(acquisitionRebuttalDlg).on('done', function() {
				$(".ui-dialog-content:visible").each(function () {
			        $( this ).dialog("option","position",$(this).dialog("option","position"));
			    });
        	});
			if($('.ui-dialog').hasClass('plcc-acquisition-rebuttal-model') && $('.ui-dialog').length > 0) {
				var $windowheight, $formButtonFixed, $rebuttalTotalHeight, $closeDialog, $dialogOffsetTop;
				$windowheight = $(window).height(),
				$formButtonFixed = $('#dialog-container').find('.form-row.form-row-button').outerHeight(true),
				$closeDialog = $('.ui-dialog').find('.ui-dialog-titlebar').outerHeight(),
				$rebuttalTotalHeight = parseInt($windowheight) - parseInt($formButtonFixed) - parseInt($closeDialog);
				$('.ui-dialog.plcc-acquisition-rebuttal-model').find('.scrollingpart').css({'height' : $rebuttalTotalHeight + 'px'});				
			}
			
			var obj = {
	    		event_name : "plc_offer_overlay"
        	}
        	tealium.triggerEvent(obj);

			preApprovedInit.acquisitionRebuttalDlgEvents();
		});
	},
	acquisitionRebuttalDlgEvents: function() {
		presentation = 'PREAPPROVED_NO';
		$("body").off('click','.plcc-get-it-button').on('click','.plcc-get-it-button',function(e){
    		presentation = "PREAPPROVED_YES";
    		var url = Urls.checkoutModalStep2; 
    		if( $(this).closest(".form-row-button").find(".isplccRebuttalApproved").length > 0 ) {
    			var rebuttalFlag = $(this).closest(".form-row-button").find(".isplccRebuttalApproved").val();
    			url = util.appendParamToURL(url, 'isrebuttalflag', rebuttalFlag);
    		}
    		
    		$.ajax({
    			url: url,
    			success: function(data) {
    				var checkoutPLCCStepTwopDlg =  dialog.create({
        		        options:{ 
        		        	dialogClass: "checkout-plcc-modal-step2",
            	        	closeOnEscape  : false,
				            closeOnOverlayClick: false,
            	        	width: "700px",
            	        	close: function () {
            	        		$('html').removeClass('no-scroll');
            	        		$('.checkout-body').removeClass('no-scroll-checkout');
            	        		if($(".acquisition-rebuttal1").length > 0 ) {
            	    				$(".acquisition-rebuttal1").hide();
            	    			} else {
            	    				$(".rebuttal-slot").addClass("hide");
            	    			}
            	        		if( madeOfferCall ){
            	        			madeOfferAjax(preApprovedInit.rebuttal,presentation);
            	        			var obj = {
        		            			event_name : "plc_offer_refused"
        		                	}
            	        			tealium.triggerEvent(obj);
            	        		}	
            		        }
        		        }
        			});
    				
    				$(checkoutPLCCStepTwopDlg).children().remove();
    				$(checkoutPLCCStepTwopDlg).append(data);
    				var obj = {
            			event_name : "plc_offer_accepted"
                	}
        			tealium.triggerEvent(obj);
    				checkoutPLCCStepTwopDlg.dialog("open");
    				util.updateselect();
    				util.updateInputFields();
    				preApprovedInit.checkoutPLCCStepTwopDlgEvents();
				}
    		});
    		
    	});
    	$("body").off('click','.plcc-nothanks-button').on('click','.plcc-nothanks-button',function(e){
    		e.preventDefault();
    		presentation = "PREAPPROVED_NO";
    		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    		scrollToActiveTab();
    	});
    	if($(".billing-cards-section,.spc-summary").find("acquisition-rebuttal1")) {
            var name = $(".acquisition-rebuttal1").data("name");
            var creditLimit = $(".acquisition-rebuttal1").data("creditlimit");
            $(".plcc-pre-approved-name").text(name);
            $(".plcc-pre-approved-creditlimit").text(creditLimit);
    	}
	},
	checkoutPLCCStepTwopDlgEvents : function() {
		validator.init();
		$('.plcc-accept-button').removeAttr('disabled');
		presentation = 'PREAPPROVED_NO';
    	$("body").off('click','.plcc-nothanks-button').on('click','.plcc-nothanks-button',function(e){
    		e.preventDefault();
    		presentation = "PREAPPROVED_NO";
    		$("#wrapper").removeAttr("style");
    		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    		scrollToActiveTab();
    	});
    	$("body").off('click','.plcc-accept-button').on('click','.plcc-accept-button',function(e){
    		//on opening pre approval/review/error step 2 modal dialog closes and made offer api gets called so make this to false
    		madeOfferCall = false;
    		e.preventDefault();
    		var $form = $(this).closest('form'),
    			action = $form.attr("action");
    		var url = action;
    		if( $(this).closest(".form-row-button").find(".isplccRebuttalApproved").length > 0 ) {
    			var rebuttalFlag = $(this).closest(".form-row-button").find(".isplccRebuttalApproved").val();
    			url = util.appendParamToURL(url, 'isrebuttalflag', rebuttalFlag);
    		}
    		var phone =  $form.find('input.phone').val();
    		var altPhone =  $form.find('input.alternativePhone').val();
    		
    		if($form.find('input.alternativePhone').hasClass('phone')){
    			$form.find('.alternativePhone').removeClass('phone');
    		}
    		
    		if ((phone == undefined || phone == '' || phone == null) && (altPhone == undefined || altPhone == '' || altPhone == null)) {
    			$form.find('.phone').addClass('required');
    			$form.find('input.phone').attr('data-required-text', Resources.PHONE_REQ_MESSAGE);
    		} else {
    			$form.find('.phone').removeClass('required');
    			$form.find('input.phone').attr('data-required-text','');
    		}
    		
    		if (!$form.valid()) {
    			$('.invalid-form').removeClass('hide');
    			$('.plcc-modal-error').removeClass('hide');
                return false;
            } else {
            	$('.invalid-form').addClass('hide');
            	$(this).attr('disabled', 'disabled');
            }
    		if( $('input[name$="dwfrm_creditapplication_submit"]').length == 0){
    			$('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo($form);
    		}
    		$.ajax({ 
    			url: url,
    			data: $form.serialize(),
    			method: 'POST', 
    			success: function(data) {
    				$("#wrapper").removeAttr("style");
    				if(data != '') {
    					$('.invalid-ssn-error').addClass('hide');
    					var dialogContent = $(data);
    					var checkoutPLCCStepTwopContinueDlg =  dialog.create({
    						options: {
    			            	closeOnEscape  : false,
        			            closeOnOverlayClick: false,
    			                width: "700px",
    			                dialogClass: "checkout-plcc-modal-step3"
    			            }
            			});
    					$(checkoutPLCCStepTwopContinueDlg).children().remove();
        				$(checkoutPLCCStepTwopContinueDlg).append(dialogContent);
        				checkoutPLCCStepTwopContinueDlg.dialog("open");
        				if($('.approved-model').length > 0 ){
		            		var obj = {
		            			event_name : "plc_registration"
		                	}
		        			tealium.triggerEvent(obj);
		            	}
        				preApprovedInit.checkoutPLCCStepTwopContinueDlgEvents();
    				} else {
    					$('.invalid-ssn-error').removeClass('hide');
    					$('.plcc-accept-button').removeAttr('disabled');
    				}
    			}
    			
    		});
    	});
	},
	checkoutPLCCStepTwopContinueDlgEvents: function() {
    	$('body').off('click','.continue-checkout,.try-again').on('click','.continue-checkout,.try-again',function(e) {
    		e.preventDefault();
			if(util.isMobile()){
				$('html').hasClass('no-scroll') && $('html').removeClass('no-scroll');
    			$('.checkout-body').hasClass('no-scroll-checkout') && $('.checkout-body').removeClass('no-scroll-checkout');  
			}
			$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    		if ($(this).hasClass('continue-checkout')) {
    			if($('.express-billing-refresh').length > 0) {
    				$(".express-billing-refresh[data-refreshurl]").trigger('click'); 
                } else if ($('.spc-summary').length > 0) {
                	var URL = Urls.updateBilling;
                	ajax.load({
                        url: URL,
                        method: 'POST',
                        callback: function (data) {
                            $('.checkout-tab.billing').html($(data).filter('.checkout-tab.billing').html());
                            require('../spc').initPreScreen();
                        }
                    });
                } else {
                	$(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                }
    			if($(".acquisition-rebuttal1").length > 0 ) {
    				$(".acquisition-rebuttal1").hide();
    			} else {
    				$(".rebuttal-slot").addClass("hide");
    			}
			}
    	});

	}
}
var credit = {
    init: function () {
        initializeEvents();
        preApprovedInit.events();
        credit.stepOneEvents();
    },
	stepOneEvents: function() {
		if ($(".checkout-stepone-modal").length > 0 ) {
	    	var $modalContent = $(".checkout-stepone-modal");
	    	
	    	var tootltipDlg =  dialog.create({
		        options:{ 
		            width: "700px", 
		            height: "auto",
		            position: { my: "top", at: "top", of : window },
		            closeOnEscape  : false,
		            closeOnOverlayClick: false,
		            draggable: false,
		            dialogClass : 'checkout-plcc-modal',
		            open: function () {
		          		$('html').addClass('no-scroll')
						$('.checkout-body').addClass('no-scroll-checkout');
		            },
		            close: function () {
						$('html').removeClass('no-scroll');
						$('.checkout-body').removeClass('no-scroll-checkout');
		            	madeOfferAjax(rebuttal,presentation);
		            	var obj = {
	            			event_name : "plc_offer_refused"
	                	}
	        	        tealium.triggerEvent(obj);
		            	scrollToActiveTab();
			        }
		         } 
		     });
			$(tootltipDlg).children().remove();
			$(tootltipDlg).append($modalContent.html());
			credit.stepOneContinueEvents();
			$(tootltipDlg).find('.plcc-preapproved-name').html($('.offer-content').data('name'));
			$(tootltipDlg).find('.plcc-preapproved-credit').html($('.offer-content').data('creditlimit'));
			tootltipDlg.dialog("open");
			imagesLoaded(tootltipDlg).on('done', function() {
				$(".ui-dialog-content:visible").each(function () {
			        $( this ).dialog("option","position",$(this).dialog("option","position"));
			    });
        	});
			if($('.ui-dialog').hasClass('checkout-plcc-modal') && $('.ui-dialog').length > 0) {
        		var $windowheight, $formButtonFixed, $checkoutStepOneTotalHeight, $closeDialog, $dialogOffsetTop;
        			$windowheight = $(window).height(),
        			$closeDialog = $('.ui-dialog').find('.ui-dialog-titlebar').outerHeight(),
        			$formButtonFixed = $('#dialog-container').find('.form-row.form-row-button').outerHeight(),
        			$dialogOffsetTop = $('.ui-dialog.checkout-plcc-modal').offset().top,
        			$checkoutStepOneTotalHeight = parseInt($windowheight) - parseInt($formButtonFixed) - parseInt($closeDialog);
        		$('.ui-dialog.checkout-plcc-modal').css({'height' : $windowheight + 'px'});
        		$('.ui-dialog.checkout-plcc-modal').find('.checkout-stepone-scroll').css({'height' : $checkoutStepOneTotalHeight + 'px'});
        		$('.ui-dialog.checkout-plcc-modal').find('.checkout-stepone-scroll').animate({ scrollTop: 0 }, "fast");
        		if($('.checkout-tabs').hasClass('spc-express-checkout')) {
        			$('html, body').animate({scrollTop: $dialogOffsetTop}, 500);
        		}
        	}
        	var eventNames = [];
			eventNames.push('plc_offer_overlay');
			eventNames.push('plc_offer_initial');
			var obj = {
	    		event_name : eventNames
        	}
	        tealium.triggerEvent(obj);
	    }
	},
	stepOneContinueEvents: function() {
		presentation = 'PREAPPROVED_NO';
		$('body').off('click','.plcc-get-it-button').on('click','.plcc-get-it-button', function(e){
			e.preventDefault();
    		var isReview = false;
    		if ($('.pt_checkout .spc-shipping').length > 0) {
    			isReview = true;
    		}
    		presentation = "PREAPPROVED_YES";
    		var url = util.appendParamToURL(Urls.checkoutModalStep2, 'isReview', isReview);
    		$.ajax({
    			url: url,
    			success: function(data) {
    				var stepTwoDialog = dialog.create({
				        options:{ 
				            width: "700px", 
				            height: "auto",
				            closeOnEscape  : false,
				            closeOnOverlayClick: false,
				            dialogClass: "checkout-plcc-modal-step2",
				            close: function () {
		            			$('html').removeClass('no-scroll');
								$('.checkout-body').removeClass('no-scroll-checkout')
				            	if( madeOfferCall ){
            	        			madeOfferAjax(rebuttal,presentation);
            	        			var obj = {
        		            			event_name : "plc_offer_refused"
            	        			}
            	        			tealium.triggerEvent(obj);
            	        		}
				            	scrollToActiveTab();
					        },
					        callback: function() {
            	            	
            	            }
				        }
    				});
    				$(stepTwoDialog).children().remove();
    				$(stepTwoDialog).append(data);
    				var obj = {
            			event_name : "plc_offer_accepted"
                	}
        			tealium.triggerEvent(obj);
    				stepTwoDialog.dialog("open");
    				util.updateselect();
    				util.updateInputFields();
    				credit.stepTwoEvents();
    			}
    		});
    	});
    	$("body").on('click','.plcc-nothanks-button', function(e){
    		e.preventDefault();
    		presentation = 'PREAPPROVED_NO';
    		madeOfferCall = true;
    		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    	});
	},
	stepTwoEvents: function() {
		validator.init();
		$('.plcc-accept-button').removeAttr('disabled');
		if(!util.isMobile()){
			$('.checkout-plcc-modal-step2 .cc-terms-iframe-content').not('.no-scroll').addClass('no-scroll');
		}
		presentation = 'PREAPPROVED_NO';
    	$("body").on('click','.plcc-nothanks-button', function(e){
    		e.preventDefault();
    		presentation = 'PREAPPROVED_NO';
    		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    		$("#wrapper").removeAttr("style");
    	});
    	$('body').on('click',".plcc-accept-button",function(e){
    		//on opening pre approval/review/error step 2 modal dialog closes and made offer api gets called so make this to false
    		e.preventDefault(); 
    		madeOfferCall = false;
    		var $form = $(this).closest('form'),
    			action = $form.attr("action");
    		var url = action;
    		var phone =  $form.find('input.phone').val();
    		var altPhone =  $form.find('input.alternativePhone').val();
    		
    		if($form.find('input.alternativePhone').hasClass('phone')){
    			$form.find('.alternativePhone').removeClass('phone');
    		}
    		
    		if ((phone == undefined || phone == '' || phone == null) && (altPhone == undefined || altPhone == '' || altPhone == null)) {
    			$form.find('.phone').addClass('required');
    			$form.find('input.phone').attr('data-required-text', Resources.PHONE_REQ_MESSAGE);
    		} else {
    			$form.find('.phone').removeClass('required');
    			$form.find('input.phone').attr('data-required-text','');
    		}
    		
    		if (!$form.valid()) {
    			$('.invalid-form').removeClass('hide');
    			$('.plcc-modal-error').removeClass('hide');
    			$('input.phone').removeClass('hide');
                return false;
            } else {
            	$('.invalid-form').addClass('hide');
            	$(this).attr('disabled', 'disabled');
            }
    		if( $('input[name$="dwfrm_creditapplication_submit"]').length == 0){
    			$('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo($form);
    		}
    		
    		$.ajax({ 
    			url: action,
    			data: $form.serialize(),
    			method: 'POST', 
    			success: function(data) {
    				$("#wrapper").removeAttr("style");
    				if(data != '') {
    					$('.invalid-ssn-error').addClass('hide');
    					var dialogContent = $(data);
    					var stepTwoContinueDialog = dialog.create({
				        	options: {
    			            	closeOnEscape  : false,
        			            closeOnOverlayClick: false,
    			                width: "700px",
    			                dialogClass: "checkout-plcc-modal-step3",
    			            }
        				});
        				$(stepTwoContinueDialog).children().remove();
        				$(stepTwoContinueDialog).append(dialogContent);
        				stepTwoContinueDialog.dialog("open");
        				if($('.approved-model').length > 0 ){
		            		var obj = {
		            			event_name : "plc_registration"
		                	}
		        			tealium.triggerEvent(obj);
		            	}
        				credit.stepTwoContinueEvent();
    				} else {
    					$('.invalid-ssn-error').removeClass('hide');
    					$('.plcc-accept-button').removeAttr('disabled');
    				}
    			}
    			
    		});
    	});
	},
	stepTwoContinueEvent: function() {
		$('body').off('click','.continue-checkout,.try-again').on('click','.continue-checkout,.try-again',function(e){
    		e.preventDefault(); 
			$('html').hasClass('no-scroll') && $('html').removeClass('no-scroll');
    		$('.checkout-body').hasClass('no-scroll-checkout') && $('.checkout-body').removeClass('no-scroll-checkout');  
    		if ($(this).hasClass('review-checkout')) {
    			$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    			require('../spc').initPreScreen();
    		} else if ($('.spc-summary').length > 0) {
				$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
            	var URL = Urls.updateBilling;
            	ajax.load({
                    url: URL,
                    method: 'POST',
                    callback: function (data) {
                        $('.checkout-tab.billing').html($(data).filter('.checkout-tab.billing').html());
                    }
                });
            } else {
    			$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    			if ($(this).hasClass('continue-checkout')) {
    				if($('.express-billing-refresh').length > 0) {
    					$(".express-billing-refresh[data-refreshurl]").trigger('click'); 
						scrollToActiveTab('expBill');
                    } else {
                    	$(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                    	require('../spc').scrollToActiveTab();
                    }
    			}
    		}
    	});
	}
};
module.exports = credit;